import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServicePopup.css";

// assets
import ai from "../../assests/green-ai.svg";
import code from "../../assests/green-data-eng.svg";
import database from "../../assests/green-data-analysics.svg";
import cloud from "../../assests/green-cloud.svg";
import iot from "../../assests/green-iot.svg";
import ar from "../../assests/green-arvr.svg";
import balckai from "../../assests/black-ai.svg";
import blackcloud from "../../assests/black-cloud.svg";
import blackar from "../../assests/black-arvr.svg";
import blackiot from "../../assests/black-iot.svg";
import blackdataeng from "../../assests/black-data-eng.svg";
import blackdataanlysics from "../../assests/black-data-analysics.svg";
import arrowIcon from "../../assests/arrow-icon.svg"
import greenarrowicon from "../../assests/green-arrow.svg"

const servicesData = [

    {
    id: "ai-ml",
    title: "AI & ML Automation",
    tagline: "Smart Automation",
    icon: {
      default: balckai,
      hover: ai,
    },
    items: [
      "Generative & Agentic AI ",
      "Advanced Analytics & Insights ",
      "MLOps & AI Platforms ",
      "Intelligent Process Automation ",
    ],
    hasRoute: true,
    routePath: "/AI-ML-Solution",
  },
  {
    id: "cloud-devops",
    title: "Cloud & DevOps",
    tagline: "Scalable Cloud",
    icon: {
      default: blackcloud,
      hover: cloud,
    },
    items: [
      "Hybrid & Multi-Cloud Optimization",
      "Cloud Migration & Modernization ",
      "DevOps & FinOps ",
      "Secure Cloud Operations ",
    ],
    hasRoute: true,
    routePath: "/cloud-services",
  },
  {
    id: "digital-engineering",
    title: "Digital Engineering",
    tagline: "Digital Precision",
    icon: {
      default: blackdataeng,
      hover: code,
    },
    items: ["Software Development & Testing",
       "Business Analysis & Solution Design", "Project Management & Delivery","Enterprise Solution Architecture  "],
    hasRoute: true,
    routePath: "/Custom-Software",
  },
  {
    id: "data-management",
    title: "Data & Analytics",
    tagline: "Actionable Insights",
    icon: {
      default: blackdataanlysics,
      hover: database,
    },
    items: [
      "Enterprise Data Strategy",
      "Data Platform Engineering ",
      "Advanced Reporting & BI ",
      "Seamless Data Migration ",
    ],
    hasRoute: true,
    routePath: "/Data-Management",
  },
  {
    id: "ar",
    title: "Extended Reality (AR/VR)",
    tagline: "Immersive Experiences",
    icon: {
      default: blackar,
      hover: ar,
    },
    items: [
      "XR Prototyping & Trials ",
      "Data Visualization in XR ",
      "Custom AR/VR Development ",
      "Immersive Training & Collaboration ",
      
      
      
    ],
    hasRoute: true,
    routePath: "/ar/vr-services",
  },
  {
    id: "iot-robotic",
    title: "IoT & Automation",
    tagline: "Smart Connectivity",
    icon: {
      default: blackiot,
      hover: iot,
    },
    items: [
      "Edge IoT Integration ",
      "Computer Vision for IoT ",
      "Robotic Process Automation (RPA) ",
    ],
    hasRoute: true,
    routePath: "/IOT-services",
  },

];


interface ServicePopupProps {
  onClose: () => void;
  onclickservice?: () => void;
}

const ServicePopup: React.FC<ServicePopupProps> = ({
  onclickservice,
  onClose,
}) => {
  const navigate = useNavigate();
  const location = useLocation(); 

  // detect screen size
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // default first service selected
    const [hoveredService, setHoveredService] = useState<any>(() => {
    const matchedService = servicesData.find(
      (service) => service.routePath === location.pathname
    );
    return matchedService || servicesData[0];
  });

    useEffect(() => {
    // ✅ Update active service when route changes
    const matchedService = servicesData.find(
      (service) => service.routePath === location.pathname
    );
    if (matchedService) {
      setHoveredService(matchedService);
    }
  }, [location.pathname]);

  const handleServiceClick = (service: any) => {
    if (service.hasRoute && service.routePath) {
      navigate(service.routePath);
      if (onclickservice) onclickservice();
      onClose();
    }
  };

  return (
    <div className="service-popup">
      {/* Header */}
      <div className="mobile-close-header">
        <h2 className="popup-title">Services</h2>
      </div>

      <div
        className={`services-container ${
          hoveredService ? "with-description" : ""
        }`}
      >
        {/* Left grid */}
        <div className="services-grid">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className={`service-card ${service.hasRoute ? "clickable" : ""} ${
                hoveredService?.id === service.id ? "active" : ""
              }`}
              onClick={() => handleServiceClick(service)}
              onMouseEnter={() => !isMobile && setHoveredService(service)} // disable hover on mobile
              style={{ cursor: service.hasRoute ? "pointer" : "default" }}
            >
              <div className="service-card-content">
                <div className="service-icon-wrapper">
                  <img
                    src={
                      isMobile
                        ? service.icon.default // always black on mobile
                        : hoveredService?.id === service.id
                        ? service.icon.hover
                        : service.icon.default
                    }
                    alt={`${service.title} icon`}
                    className="service-icon-pop"
                  />
                </div>
                <div className="service-text">
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "flex-end",
                    }}
                  >
    <h3 className="service-title">{service.title}</h3>
{service.hasRoute && (
  <div className="service-arrow">
    <img
      src={
           !isMobile && hoveredService?.id === service.id ? greenarrowicon : arrowIcon
}
      alt="Go to service"
    />
  </div>
)}
  </div>
    <p className="service-tagline">{service.tagline}</p>
  </div>
</div>
            </div>
          ))}
        </div>

        {/* Right description panel */}
        {!isMobile && hoveredService && (
          <div className="service-description">
            <h3>{hoveredService.title}</h3>
            <ul>
              {hoveredService.items.map((item: string, i: number) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};


export default ServicePopup;
